export const classicTilesPerRow = 4
export const squareTilesPerRow = 7
export const classicNextRowsOffset = 3
export const squareNextRowsOffset = 5
export const limitRowsPerList = 100
